import { useState } from "react";
import { Link } from "react-router-dom";
import { Building2, Hotel, Home, Dumbbell, Car, Trees } from "lucide-react";

const SPACES = [
  { id: "corporate", label: "Offices & Corporate", icon: Building2, desc: "Tile carpets, felt & commercial flooring built for high footfall workplaces.", cats: ["Carpets", "Commercial Flooring", "Felt"] },
  { id: "hospitality", label: "Hotels & Hospitality", icon: Hotel, desc: "Elegant carpets and entrance matting that make a lasting first impression.", cats: ["Carpets", "Mats"] },
  { id: "residential", label: "Residential", icon: Home, desc: "Doormats, decorative mats and soft grass for homes and apartments.", cats: ["Mats", "Artificial Grass"] },
  { id: "sports", label: "Gyms & Sports", icon: Dumbbell, desc: "Durable matting and sports-grade grass for training and play areas.", cats: ["Mats", "Artificial Grass"] },
  { id: "automotive", label: "Automotive", icon: Car, desc: "Custom-fit car mats that are anti-slip and easy to clean.", cats: ["Car Mat"] },
  { id: "outdoor", label: "Outdoor & Landscaping", icon: Trees, desc: "Artificial grass and hard grass tiles for terraces, patios and gardens.", cats: ["Artificial Grass"] },
];

export function ProductsForEverySpace() {
  const [active, setActive] = useState(SPACES[0]);

  return (
    <section data-testid="products-for-every-space-section" className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
      <div className="mb-10 text-center">
        <span className="font-spec text-xs font-semibold uppercase tracking-[0.2em] text-[#10B981]">Applications</span>
        <h2 className="mt-2 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
          Products for Every Space
        </h2>
        <div className="mx-auto mt-3 h-1 w-12 rounded-full bg-gradient-to-r from-[#10B981] to-[#25D366]" />
      </div>

      <div className="flex flex-wrap justify-center gap-2">
        {SPACES.map((s) => (
          <button
            key={s.id}
            onClick={() => setActive(s)}
            data-testid={`space-tab-${s.id}`}
            className={`flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold transition-all ${
              active.id === s.id
                ? "bg-[#0B1B3D] text-white shadow-md"
                : "bg-white text-slate-600 ring-1 ring-slate-200 hover:ring-[#10B981]"
            }`}
          >
            <s.icon className="h-4 w-4" /> {s.label}
          </button>
        ))}
      </div>

      <div key={active.id} className="mt-8 animate-fade-up rounded-3xl border border-slate-200 bg-white p-8 shadow-sm sm:p-12">
        <div className="flex flex-col items-start gap-6 sm:flex-row sm:items-center">
          <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-[#ECFDF5] text-[#059669] ring-1 ring-[#A7F3D0]">
            <active.icon className="h-8 w-8" />
          </span>
          <div className="flex-1">
            <h3 className="font-display text-2xl font-bold text-[#0B1B3D]">{active.label}</h3>
            <p className="mt-2 max-w-2xl text-slate-600">{active.desc}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              {active.cats.map((c) => (
                <Link key={c} to={`/catalogue?category=${encodeURIComponent(c)}`}
                  className="rounded-full bg-slate-100 px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-[#ECFDF5] hover:text-[#059669]">
                  {c} →
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
